import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export const NavIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary,
})) as typeof IconButton;
